import { createTypes } from "./createTypes";

export default createTypes("GET_ENGAGEMENTS");
